import React from 'react';

import { Select, Tooltip } from 'antd';

import { DocumentFilterOptionSchema } from '@app/models/wms';

export interface DocumentFilterSelectBaseProps {
  disabled?: boolean;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder: string;
}

interface BaseDocumentFilterSelectProps extends DocumentFilterSelectBaseProps {
  error?: boolean;
  fetching?: boolean;
  options: DocumentFilterOptionSchema[];
}

export const BaseDocumentFilterSelect: React.FC<BaseDocumentFilterSelectProps> = ({
  disabled,
  error,
  fetching,
  options,
  value,
  onChange,
  placeholder,
}) => (
  <Select
    disabled={disabled || error}
    style={{ width: '100%' }}
    mode="multiple"
    allowClear
    maxTagPlaceholder={(omittedValues) => (
      <Tooltip
        styles={{ root: { pointerEvents: 'none' } }}
        title={omittedValues.map(({ label }) => label).join(', ')}>
        <span>+ {omittedValues.length}...</span>
      </Tooltip>
    )}
    maxTagCount="responsive"
    placeholder={placeholder}
    value={value}
    loading={fetching}
    options={options}
    dropdownStyle={{ position: 'fixed' }}
    onChange={onChange}
  />
);
